/* Insieme di dati selezionato
null | {"value": "train" | "test" | "none", ...}
*/
import { createContext } from "react";
const SelectedSetContext = createContext({
    selectedSet: null,
    setSelectedSet: (set) => {}
  });
export default SelectedSetContext;